const imgTeamUiUxUiUx3Ball = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const imgMain52 = "./assets/figma/32361f13-4c7e-4ff4-893d-ce18c0702c6f.png";
const img2026923382 = "./assets/figma/08e2f5b2-0166-47a0-8883-dbe8a85233c5.png";
const img2026923372 = "./assets/figma/21e70e50-7835-449e-9d28-8efd25db7968.png";
const img2026923373 = "./assets/figma/3500582e-0fee-4a07-a464-dd16a020d3e0.png";
const img2026923383 = "./assets/figma/0085039f-b432-4896-a62d-71ad8c5246f2.png";
const img2026923374 = "./assets/figma/200cf5f5-c51b-4c0c-b925-cc1378776bbd.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const imgDingUiux2 = "./assets/figma/68cc449e-e2ee-4474-9af8-7bbbea13f420.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const imgRectangle243 = "./assets/figma/7650ce0d-e29d-436a-9704-2d0f7f1caa0b.svg";
const img1 = "./assets/figma/80ad5ed2-b8f8-4fc7-ae34-3bdb1e3cfeba.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgRectangle244 = "./assets/figma/606be6bd-73fb-4330-90a9-63782aa5354e.svg";
const imgClose = "./assets/figma/29a7a452-30d6-4edb-906b-94aecb1abac3.svg";

export default function TeamUiUxUiUx3Ball() {
  return (
    <div className="s0 s1" data-node-id="875:1065" data-name="TEAM_UI/UX/UI/UX 3 ball">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s470 s471 s9 s10 s472" src={imgTeamUiUxUiUx3Ball} />
        </div>
      </div>
      <div className="s2 s12 s13 s473 s15" data-node-id="875:1069" data-name="image 14" />
      <p className="s23 s2 s51 s94 s52 s27 s29 s33 s474 s54" data-node-id="875:1070">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s55 s27 s29 s475 s57" data-node-id="875:1071">
        <p className="s31 s32 s379 s0 s28 s58 s380" data-node-id="875:1072">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="875:1073">
          <p className="s39 s40">
            {`UI/UX팀은 DING AI LAB에 참여한 여러 팀의 작업물과 AI 활용 과정을 한곳에 기록한 인터랙티브 아카이브 `}
            <br aria-hidden />
            웹사이트를 제작했다. 각 구슬은 하나의 프로젝트를 상징하며, 사용자는 구슬을 선택하고 굴리면서 결과물과 제작
            <br aria-hidden />
            {`과정을 순차적으로 탐색할 수 있다. 상세 페이지에는 사용한 AI, 프롬프트,  작업 과정과 활용 방법을 기록해 AI가`}
          </p>
          <p className="s39">아이디어 발상부터 이미지 제작, 디자인 수정과 결과 발전에 어떻게 사용되었는지 보여준다. 팀마다 AI를 선택하고 조합한 방식을 비교할 수 있으며, 구슬 중심의 인터랙션을 통해 능동적인 탐색 경험과 향후 AI 디자인 작업에 활용할 수 있는 참고 자료를 제공한다.</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s476 s27 s29 s61 s477 s54" data-node-id="875:1074">
        UI/UX
      </p>
      <div className="s2 s478 s479 s480 s481" data-node-id="875:1075" data-name="main5 2">
        <img alt="" className="s2 s3 s9 s262 s4 s1" src={imgMain52} />
      </div>
      <div className="s2 s16 s17 s18 s19 s20 s482 s22" data-node-id="875:1076">
        <div className="s23 s16 s17 s24 s25 s483 s26 s27 s0 s28 s29 s30" data-node-id="875:1077">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:1078">
            PROJECT OVERVIEW
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:1079">
            INTERACTIVE WEBSITE
          </p>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="875:1080">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="875:1081">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:1082">
            MEMBERS
          </p>
          <div className="s35 s36 s0 s28 s37 s34" data-node-id="875:1083">
            <p className="s39 s40">
              김근우
              <br aria-hidden />
              김시현
              <br aria-hidden />
              오한비
              <br aria-hidden />
              최진영
            </p>
            <p className="s39">​</p>
          </div>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s20 s27 s29 s64 s484 s334" data-node-id="875:1084">
        WORK
      </p>
      <div className="s2 s16 s17 s18 s19 s36 s20 s485 s66" data-node-id="875:1085">
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1086">
          <div className="s192 s486 s487 s488 s0 s489 s198 s348 s490" data-node-id="875:1087" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <img alt="" className="s2 s3 s9 s105 s4 s489 s1" src={img2026923382} />
          </div>
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:1088" />
          <p className="s23 s192 s31 s94 s491 s346 s27 s0 s198 s29 s33 s85 s492" data-node-id="875:1089">
            GRAPHIC 1 BALL
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1090">
          <div className="s192 s493 s494 s495 s0 s489 s198 s348 s496" data-node-id="875:1091" data-name="이미지 2026. 9. 2. 오후 3.37 2">
            <img alt="" className="s2 s3 s9 s105 s4 s489 s1" src={img2026923372} />
          </div>
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:1092" />
          <p className="s23 s192 s31 s94 s497 s346 s27 s0 s198 s29 s33 s85 s498" data-node-id="875:1093">
            GRAPHIC 2 BALL
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1094">
          <div className="s192 s499 s500 s501 s0 s489 s198 s348 s502" data-node-id="875:1095" data-name="이미지 2026. 9. 2. 오후 3.37 3">
            <img alt="" className="s2 s3 s9 s105 s4 s489 s1" src={img2026923373} />
          </div>
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:1096" />
          <p className="s23 s192 s31 s94 s503 s346 s27 s0 s198 s29 s33 s85 s504" data-node-id="875:1097">
            UI/ux BALL
          </p>
        </div>
      </div>
      <div className="s2 s16 s17 s18 s19 s36 s20 s505 s506" data-node-id="875:1098">
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1099">
          <div className="s192 s335 s336 s337 s339 s495 s338 s0 s198" data-node-id="875:1100">
            <div className="s192 s507 s339 s340 s0 s489 s198 s348 s71" data-node-id="875:1101" data-name="이미지 2026. 9. 2. 오후 3.38 2">
              <img alt="" className="s2 s3 s9 s105 s4 s489 s1" src={img2026923383} />
            </div>
          </div>
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:1102" />
          <p className="s23 s192 s31 s94 s508 s346 s27 s0 s198 s29 s33 s85 s509" data-node-id="875:1103">
            package/goods ball
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1104">
          <div className="s192 s510 s511 s512 s0 s489 s198 s348 s513" data-node-id="875:1105" data-name="이미지 2026. 9. 2. 오후 3.37 2">
            <img alt="" className="s2 s3 s9 s105 s4 s489 s1" src={img2026923374} />
          </div>
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:1106" />
          <p className="s23 s192 s31 s94 s514 s346 s27 s0 s198 s29 s33 s85 s515" data-node-id="875:1107">
            motion BALL
          </p>
        </div>
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="875:1108">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s128 s126 s10 s104" data-node-id="875:1109">
        <div className="s2 s129">
          <img alt="" className="s49 s9 s1" src={imgRectangle243} />
        </div>
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="875:1110" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="875:1111">
          <div className="s111 s0 s28 s112" data-node-id="875:1112" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="875:1117">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="875:1118">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="875:1119">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1120">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1121">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="875:1122">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1123">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1124">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="875:1125">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1126">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1127">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s106 s2 s353 s126 s10 s104" data-node-id="875:1128">
        <div className="s2 s355">
          <img alt="" className="s49 s9 s1" src={imgRectangle244} />
        </div>
      </div>
      <div className="s2 s16 s17 s24 s130 s26 s20 s132 s133" data-node-id="875:1129" data-name="PROJECT_CATEGORY_TABS_UIUX">
        <div className="s16 s17 s18 s42 s134 s0 s28 s34" data-node-id="875:2787">
          <p className="s23 s135 s31 s32 s136 s27 s0 s137 s138" data-node-id="875:1130">
            UI/UX
          </p>
        </div>
        <div className="s16 s17 s139 s18 s0 s28 s140" data-node-id="856:3963" data-name="PROJECT_CATEGORY_TABS_UI/UX">
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3964" data-name="TAB_GRAPHIC 1 ball">
            <div aria-hidden className="s2 s313 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3965">
              GRAPHIC 1 ball
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3966" data-name="TAB_GRAPHIC 2 ball">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3967">
              GRAPHIC 2 ball
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <div className="s16 s81 s17 s18 s42 s142 s143 s144 s0 s145 s28" data-node-id="856:3968" data-name="TAB_UI/UX ball">
            <div aria-hidden className="s2 s152 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s29 s148 s54" data-node-id="856:3969">
              Ui/ux ball
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </div>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3970" data-name="TAB_PACKAGE/GOODS ball">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3971">
              package/goods ball
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3972" data-name="TAB_MOTION ball">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3973">
              motion ball
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
        </div>
      </div>
      <div className="s2 s67 s153 s516" data-node-id="875:577">
        <div className="s2 s5 s517 s153 s156 s157 s516 s158" data-node-id="856:3961" />
        <p className="s23 s2 s31 s32 s535 s27 s29 s160 s519 s54" data-node-id="856:3962">
          Ui/ux ball
        </p>
        <div className="s106 s2 s67 s126 s520" data-node-id="856:3977">
          <div className="s106 s2 s521 s126 s165 s4 s145 s146 s520 s522" data-node-id="856:3978">
            <div aria-hidden className="s2 s147 s3 s145" />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s2 s16 s17 s24 s167 s523 s26 s524 s27 s29 s525 s526" data-node-id="856:3979">
            <div className="s16 s17 s24 s172 s527 s26 s0 s28 s528" data-node-id="856:3980">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:3981">
                Prompt
              </p>
              <div className="s35 s36 s0 s28 s174 s34 s38" data-node-id="856:3982">
                <p className="s175 s40">[이미지 메인 프롬프트]</p>
                <p className="s175 s40">​</p>
                <p className="s175 s40">그래픽 1팀을 상징하는 새로운 구슬 이미지를 만들어줘.색상은 첨부한 디자인 시스템 색상표에 있는 색을 정확하게 사용하고 큰 색 덩어리들이 구의 전체 표면에서 자연스럽게 이어지고 서로 부드럽게 섞이게 해줘. 색의 중심은 분명하게 보이면서 경계에서만 자연스럽게 연결되게 해줘.표면에는 참고 이미지처럼 작고 촘촘한 결정 조각이 모여 있는 듯한 자글자글한 질감을 넣어줘. 매끈한 구 표면에 평면 그래픽으로 인쇄된 질감처럼 표현해줘.구 전체에는 밝고 선명한 흰색 네트워크 선과 원형 노드를 넣어줘. 선과 노드는 서로 규칙적으로 연결하고, 둥근 구 표면 전체를 감싸는 구조로 만들어줘. 구의 원근과 곡률 때문에 외곽으로 갈수록 선이 자연스럽게 휘고 촘촘해 보이게 해줘. 구 가장자리에서도 선과 노드가 구면을 따라 뒤쪽으로 이어지는 것처럼 표현해줘.구는 완벽하게 둥근 형태로 화면 중앙에 하나만 배치하고, 잘리지 않게 전체가 보여야 해. 정면에서 약간 입체적으로 보이는 3D 구체 이미지로 만들어줘. 배경은 깨끗한 흰색으로 설정하고, 그림자는 바닥에 아주 약하게만 넣어줘.이 이미지는 Tripo에서 3D 텍스처 참고 이미지로 사용할 예정이야. Tripo에서 색과 선명도가 약해질 것을 고려해서 색의 채도와 명암 대비를 조금 높이고, 흰색 네트워크 선과 노드도 또렷하게 표현해줘. 최대한 고해상도로 만들어줘.유리막은 나중에 Blender에서 별도로 씌울 예정이므로 지금 구슬은 매끈한 무광 재질이어야 해.</p>
                <p className="s175 s40">​</p>
                <p className="s175 s40">[네거티브 프롬프트]</p>
                <p className="s175 s40">​</p>
                <p className="s175 s40">세 색이 각각 따로 나뉜 구역처럼 보이는 구성, 작은 얼룩이나 물감이 마구 섞인 마블링, 실제로 울퉁불퉁한 표면, 깨진 돌처럼 보이는 표면, 서로 엉키거나 끊어진 네트워크 선과 노드, 구의 앞에 평면으로 떠 있는 네트워크 무늬, 물결처럼 구불거리는 개별 네트워크 선, 잘리거나 화면 밖으로 벗어난 구.유리, 투명 재질, 강한 광택, 금속, 반사광, 과도한 하이라이트, 돌출된 선, 입체 노드, 표면 요철, 균열, 구멍, 거친 돌 질감은 넣지 마.</p>
                <p className="s175">​</p>
              </div>
            </div>
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:3983">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:3984">
                AI TOOLS
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="856:3985">
                Chat GPT, Tripo
              </p>
            </div>
          </div>
        </div>
      </div>
      <button className="s2 s49 s141 s211 s212 s213" data-node-id="891:178" data-name="close">
        <img alt="" className="s2 s49 s3 s9 s1" src={imgClose} />
      </button>
      <div className="s2 s536 s530 s531" data-node-id="1018:32" data-name="DING_UIUX 2">
        <img alt="" className="s2 s3 s9 s262 s4 s1" src={imgDingUiux2} />
      </div>
    </div>
  );
}